import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { radius } from '@karehero/llama/theme/radius';

import { Box, Stack } from '@mui/material';

import { usePhoneScreen } from '@/designs-dev/device/PhoneScreenContext';

// iOS-style action sheet: a floating rounded panel inset from the screen
// edges, over a dimmed scrim — for confirm-style choices (e.g. delete).
// Distinct from BottomSheet, which docks full-width for content.
const ActionSheet = ({
  onClose,
  children,
}: {
  onClose: () => void;
  children: ReactNode;
}) => {
  const screenEl = usePhoneScreen();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(true), []);

  const close = () => {
    setOpen(false);
    window.setTimeout(onClose, 220);
  };

  const sheet = (
    <>
      <Box
        onClick={close}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'common.black',
          zIndex: 50,
          opacity: open ? 0.4 : 0,
          transition: 'opacity 220ms ease',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: 12,
          right: 12,
          bottom: 12,
          zIndex: 51,
          bgcolor: 'background.paper',
          borderRadius: `${radius.lg}px`,
          p: 1.5,
          transform: open ? 'translateY(0)' : 'translateY(40px)',
          opacity: open ? 1 : 0,
          transition: 'transform 220ms ease, opacity 220ms ease',
        }}
      >
        <Stack spacing={1.5}>{children}</Stack>
      </Box>
    </>
  );

  return screenEl ? createPortal(sheet, screenEl) : sheet;
};

export default ActionSheet;
